import React, { memo, Fragment, PropsWithChildren } from 'react';
import { HTMLService } from '@business/services';
import { JobDescriptionResponse, JobAuthorify, JOB_DESCRIPTION_AUTHORITIES } from '@business/entities/library';
import { R } from '@core/utils/r';

interface TextBlockProps {
  title?: string;
  mb2?: boolean;
}

export const TextBlock = memo((props: PropsWithChildren<TextBlockProps>) => {
  return (
    <div className={`d-flex flex-column`} style={{ flex: 1 }}>
      {!!props.title && (
        <p style={{ color: '#000', fontWeight: 500 }} className={`mb-0 font-size-16 `}>
          {props.title}
        </p>
      )}
      {!!props.children && <div className={`font-size-14 ${props.mb2 ? 'mb-2' : 'mb-4'}`}>{props.children}</div>}
    </div>
  );
});

export interface JobDescriptionComponentProps {
  content: JobDescriptionResponse;
  title: string;
}

export const JobDescriptionComponent = memo((props: JobDescriptionComponentProps) => {
  const { title } = props;
  const { overview, youReports, reportYou, functions, education, experience, skills, physicalRequirements, kpi } = props.content;

  if (!props.content || (props.content && !props.content.functions)) return <Fragment />;

  return (
    <Fragment>
      {!R.isEmpty(title) && <h3>{title}</h3>}
      <TextBlock title="Overview">{HTMLService.toReact(overview)}</TextBlock>
      <TextBlock title="Who You Report To">{youReports}</TextBlock>
      <TextBlock title="Who Reports To You">{reportYou}</TextBlock>
      <TextBlock title="Function Definitions">
        {[JobAuthorify.getApproval, JobAuthorify.handle, JobAuthorify.act].map((act, index) => (
          <div key={index} className="d-flex">
            <div className="ml-1">{index + 1} - </div>
            <div>{JOB_DESCRIPTION_AUTHORITIES[act]}</div>
          </div>
        ))}
      </TextBlock>
      <TextBlock title="Functions"></TextBlock>
      <div className="mb-2"></div>
      {functions.map((f, index) => (
        <div className="ml-2 d-flex" key={index}>
          <div className="flex-fill" style={{ fontSize: '14px' }}>
            ({[JobAuthorify.getApproval, JobAuthorify.handle, JobAuthorify.act].indexOf(f.authorityLevel) + 1}) {f.function}
            <hr />
          </div>
        </div>
      ))}

      {!R.isEmpty(education) && <TextBlock title="Education">{education}</TextBlock>}
      {!R.isEmpty(experience) && <TextBlock title="Experience">{experience}</TextBlock>}
      {!R.isEmpty(skills) && <TextBlock title="Skills">{skills}</TextBlock>}
      {!R.isEmpty(physicalRequirements) && <TextBlock title="Physical Requirements">{physicalRequirements}</TextBlock>}
      {!R.isEmpty(kpi) && <TextBlock title="KPIs/Metrics">{kpi}</TextBlock>}
    </Fragment>
  );
});
